namespace $.$$ {

	export class $bog_max_list extends $.$bog_max_list {

		override view_window( next?: [ number, number ] ): [ number, number ] {
			return [ 0, this.rows().length ]
		}

	}

}
